var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_1459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.218 11.7257H14.3224C13.8912 11.7257 13.5412 11.3757 13.5412 10.9445C13.5412 10.5132 13.8912 10.1632 14.3224 10.1632H24.218C24.6492 10.1632 24.9992 10.5132 24.9992 10.9445C24.9992 11.3757 24.6492 11.7257 24.218 11.7257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3119 15.6318C20.1118 15.6318 19.9119 15.5557 19.7597 15.4028C19.4545 15.0974 19.4545 14.6026 19.7597 14.2975L23.1139 10.9435L19.7597 7.58935C19.4545 7.28418 19.4545 6.78943 19.7597 6.48427C20.0651 6.17891 20.5598 6.17891 20.865 6.48427L24.7711 10.3904C25.0763 10.6956 25.0763 11.1903 24.7711 11.4955L20.865 15.4016C20.7118 15.5557 20.5119 15.6318 20.3119 15.6318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33314 25.0065C8.11017 25.0065 7.89866 24.9752 7.68733 24.9096L1.41864 22.8212C0.565702 22.5232 0 21.7285 0 20.8401V2.09064C0 0.94169 0.934381 0.00730896 2.08333 0.00730896C2.3061 0.00730896 2.51762 0.0385885 2.72914 0.104199L8.99764 2.19268C9.85077 2.4906 10.4163 3.28537 10.4163 4.17378V22.9232C10.4163 24.0721 9.48209 25.0065 8.33314 25.0065ZM2.08333 1.56976C1.79686 1.56976 1.56245 1.80417 1.56245 2.09064V20.8401C1.56245 21.0619 1.71141 21.268 1.92388 21.3421L8.1632 23.4212C8.20802 23.4357 8.26638 23.4441 8.33314 23.4441C8.61961 23.4441 8.85383 23.2097 8.85383 22.9232V4.17378C8.85383 3.95196 8.70487 3.74579 8.49239 3.67178L2.25308 1.59265C2.20826 1.57815 2.1499 1.56976 2.08333 1.56976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8849 8.34044C15.4536 8.34044 15.1036 7.99046 15.1036 7.55922V2.87187C15.1036 2.15415 14.5194 1.56976 13.8017 1.56976H2.08335C1.65211 1.56976 1.30212 1.21977 1.30212 0.788534C1.30212 0.357296 1.65211 0.00730896 2.08335 0.00730896H13.8017C15.3819 0.00730896 16.6661 1.29168 16.6661 2.87187V7.55922C16.6661 7.99046 16.3161 8.34044 15.8849 8.34044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8017 21.8816H9.63505C9.20381 21.8816 8.85382 21.5316 8.85382 21.1004C8.85382 20.6691 9.20381 20.3192 9.63505 20.3192H13.8017C14.5194 20.3192 15.1036 19.7348 15.1036 19.0171V14.3297C15.1036 13.8985 15.4536 13.5485 15.8849 13.5485C16.3161 13.5485 16.6661 13.8985 16.6661 14.3297V19.0171C16.6661 20.5972 15.3819 21.8816 13.8017 21.8816Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_1459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.00653076)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2ba591552803f25a59f11ccf693b6a52.svg";
export { ForwardRef as ReactComponent };